<div class="save-cancel-button-row">
  <ng-container *ngIf="buttonConfig.showCancel">
    <button
      id="mat-cancel-button"
      class="header-text"
      type="button"
      mat-button
      mat-raised-button
      color="primary"
      (click)="cancel()"
    >
      {{ buttonConfig.cancel | uppercase }}
    </button>
  </ng-container>
  <button
    id="mat-form-submit-button"
    class="header-text"
    type="submit"
    mat-button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="shouldDisable || (disableState$ | async)"
  >
    {{ buttonConfig.save | uppercase }}
  </button>
</div>
